import { Box, Grid, Typography, useTheme } from "@mui/material";
import MFCheckbox from "../../../lib/formik/Checkbox";
import { Form, Formik } from "formik";
import { MFSubmitButton } from "../../../lib/formik";
import { ArnDialog } from "../ArnDialog";
import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import { getSelfDeclaration, subbrokerGenerateOtp } from "../actions";
import { useDispatch } from "react-redux";
import { getSelfDeclarationResponseBody, LoadingKeys, SubbrokerGenerateOtpResponseBody, SubbrokerDeclarationDocType, SUBBROKER_SELF_DECLARATION_FLOW } from "../types";
import dayjs from "dayjs";
import { todaysdate } from "../../../utils/utilityFunctions";
import DocumentDialog from "./DocumentDialog";
import { useHistory } from "react-router";

const initialValues = {
  productDeclaration: [
    { productType: 'MF', selected: true, isSelfDeclared: false, prevValue: false, declarationTime: '', version: '', arn: { validityDate: '', document: {} } },
    // { productType: 'AIF', selected: true, isSelfDeclared: false, prevValue: false, declarationTime: '' },
    { productType: 'PMS', selected: true, isSelfDeclared: false, prevValue: false, declarationTime: '' },
    // { productType: 'OTHERS', selected: true, isSelfDeclared: false, prevValue: false, declarationTime: '' },
  ]
}

const selfDeclared = (productType: string) => {
  return `I self declare that I can transact in ${productType} product.`;
};

export default function SelfDeclaration() {
  const theme = useTheme();
  const history = useHistory();
  const [values, setValues] = useState<typeof initialValues>(initialValues);
  // const [isSelfDeclared, setSelfDeclared] = useState<boolean>(false);
  const [isArnOpen, setArnOpen] = useState<boolean>(false);
  const [isLoading, setLoading] = useState<LoadingKeys | null>();
  const [isMfPopupOpen, setMfPopupOpen] = useState<boolean>(false);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  async function getSubBrkDecStatus() {
    try {
      setLoading(LoadingKeys.GET_SELF_DECLARE);
      const res = await dispatch(getSelfDeclaration()) as unknown as getSelfDeclarationResponseBody;
      if (!res || !res.isSuccess) {
        throw new Error(res.message);
      }
      setValues((prev) => ({
        ...prev,
        productDeclaration: prev.productDeclaration.map((item) => {
          const match = res.data?.find((d) => d.productType === item.productType);
          return match
            ? { ...item, isSelfDeclared: match.isSelfDeclared, prevValue: match.isSelfDeclared, declarationTime: match.declarationTime }
            : item;
        }),
      }));
      // setSelfDeclared(res.data.some((item) => item.isSelfDeclared));
    } catch (e: any) {
      enqueueSnackbar(e.message || 'Self Declaration Failed', {
        variant: 'error',
        autoHideDuration: 3000,
      });
    } finally {
      setLoading(null);
    }
  };

  useEffect(() => {
    getSubBrkDecStatus();
  }, []);

  const handleSubmit = async (values: typeof initialValues) => {
    try {
      setLoading(LoadingKeys.SUBBROKER_SELF_DECLARE);
      const payload = {
        productDeclaration: values.productDeclaration
          .filter((item) => item.isSelfDeclared && !item.prevValue)
          .map((item) => {
            const version = (item as { version?: string }).version;
            return {
              productType: `${item.productType}`.toUpperCase(),
              isSelfDeclared: item.isSelfDeclared,
              ...(version ? { version } : {}),
            };
          }),
      };
      
      const res = await dispatch(subbrokerGenerateOtp({flow:SUBBROKER_SELF_DECLARATION_FLOW})) as unknown as SubbrokerGenerateOtpResponseBody;

      if (!res || !res.isSuccess || !res.data?.length) {
        throw new Error(res?.message || 'Failed to generate OTP');
      }
      history.push({
        pathname: '/my-profile/otp-screen',
        state: {
          id: res.data[0].id,
          token: res.data[0].token,
          message: res.data[0].message,
          numberOfOTPTries: res.data[0].numberOfOTPTries ?? 0,
          payload: payload,
        },
      });

    } catch (e: any) {
      enqueueSnackbar(e.message || 'Failed to generate OTP', {
        variant: 'error',
        autoHideDuration: 3000,
      });
      setLoading(null);
    }
  };

  const handleArnClose = () => {
    setArnOpen(false);
  }

  return (
    <>
      <Typography variant='h2' sx={{ color: theme.palette.primary[500] }}>
        {/* Self Declaration and ARN Document Upload */}
        Self Declaration
      </Typography>
      <Formik
        initialValues={values}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ values, dirty,setFieldValue }) => (
          <>
          <Form>
            <Grid container columnGap={2} rowGap={2} sx={{ mt: 3 }}>
              {values.productDeclaration.map((item, index) => (
                <Grid
                  key={item.productType}
                  container
                  item
                  xs={12}
                  sx={{
                    p: 2,
                    border: `1px solid ${theme.palette.primary.main}`,
                    borderRadius: '15px'
                  }}
                >
                  <Grid item xs={12}>
                    {/* <MFCheckbox
                      name={`products[${index}].selected`}
                      label={item.productType}
                      onChange={(_, checked) => {
                        setFieldValue(`products[${index}].selected`, checked);
                        if (!checked) {
                          setFieldValue(`products[${index}].isSelfDeclared`, false)
                          item.arn && setFieldValue(`products[${index}].arn`, { validityDate: '', document: {} });
                        }
                      }}
                    /> */}
                      {/* {console.log('item', item)} */}
                      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="body_500" sx={{ color: 'primary.main', fontWeight: 600 }} >
                          {item.productType}
                        </Typography>
                        {item.declarationTime && item.isSelfDeclared
                          && <Typography variant="overline_400" sx={{ color: 'primary.main', fontWeight: 500 }}>
                            Self Declaration Provided on: {dayjs(item?.declarationTime ?? todaysdate()).format('DD/MM/YYYY')}
                          </Typography>}
                      </Box>
                    </Grid>
                    <Grid item xs={1} sx={{ display: { xs: 'none', sm: 'block' } }} />
                    <Grid item xs={12} sm={8}>
                      <MFCheckbox
                        name={`productDeclaration[${index}].isSelfDeclared`}
                        label={selfDeclared(item.productType)}
                        disabled={item.prevValue || isLoading === LoadingKeys.SUBBROKER_SELF_DECLARE || isLoading === LoadingKeys.GET_SELF_DECLARE}
                        onHoverText={item.prevValue ? 'Self Declaration is already done' : ''}
                        onChange={(e) => {
                          if (e.target.checked) {
                            if (item.productType === 'MF') {
                              setMfPopupOpen(true);
                            } else {
                              setFieldValue(`productDeclaration[${index}].isSelfDeclared`, true);
                            }
                          } else {
                            setFieldValue(`productDeclaration[${index}].isSelfDeclared`, false);

                          }

                        }}
                      />
                    </Grid>
                    {/* {item?.arn
                    && <Grid item xs={12} sm={3} sx={{ textAlign: 'right' }}>
                      <Button
                        sx={{
                          alignSelf: 'flex-end',
                          color: 'textDark.primary',
                          backgroundColor: 'primary.500',
                          border: `1px solid ${theme.palette.primary[500]}`,
                          padding: "8px",
                          ...theme.typography.body_600,
                          "&:hover, &.Mui-focusVisible": {
                            color: 'primary.500',
                            backgroundColor: "background.default"
                          },
                        }}
                        onClick={() => setArnOpen(true)}

                      >
                        Upload ARN
                      </Button>
                    </Grid>} */}
                </Grid>
              ))}

                <Grid item xs={12} sx={{ display: { xs: 'none', sm: 'block' } }} />
                <Grid item xs={12} sm={3}>
                  <MFSubmitButton
                    label="Submit"
                    // disabled={!dirty}
                    loadingEnable={isLoading === LoadingKeys.SUBBROKER_SELF_DECLARE}
                    disabled={!dirty || isLoading === LoadingKeys.SUBBROKER_SELF_DECLARE || isLoading === LoadingKeys.GET_SELF_DECLARE}
                  />
                </Grid>
              </Grid>
            </Form>
            <DocumentDialog
              open={isMfPopupOpen}
              documentType={SubbrokerDeclarationDocType.MF}
              onCancel={() => setMfPopupOpen(false)}
              onAccept={(version) => {
                const mfIdx = values.productDeclaration.findIndex(
                  (p) => p.productType === 'MF'
                );
                if (mfIdx >= 0) {
                  setFieldValue(`productDeclaration[${mfIdx}].isSelfDeclared`, true);
                  setFieldValue(`productDeclaration[${mfIdx}].version`, version);
                }
                setMfPopupOpen(false);
              }}
            />
          </>
        )}
      </Formik>
      <ArnDialog isDialogOpen={isArnOpen} handleDialogClose={handleArnClose} />
    </>
  )
}
